import type { OverwriteScopes } from "hoxton-types";
import { OverwriteScope } from "hoxton-shared/enums/overwrites";

export const EditableGroupScopeLabel = "";
export const ExportGroupScopeLabel = "All Sizes";

export const TemplateOverwriteScopes: readonly OverwriteScopes[] = [
    OverwriteScope.Template,
    OverwriteScope.EditableGroupTemplate
];

export const OverwriteScopeOrder = {
    [OverwriteScope.Campaign]: 1,
    [OverwriteScope.Template]: 2,
    [OverwriteScope.EditableGroup]: 3,
    [OverwriteScope.EditableGroupTemplate]: 4
} as const;
